// extracted by mini-css-extract-plugin
export var aiStarIcon = "_cp-4";
export var closeButton = "_cp-6";
export var dismissButton = "_cp-3";
export var editImageWithAiContainer = "_cp-8";
export var imageUploadWrapper = "_cp-7";
export var misspelledWord = "_cp-5";
export var spellCheckContainer = "_cp-2";
export var spin = "_cp-1";
export var spinning = "_cp-0";